import { getList, getcurrentList, getHistoryList } from '@/api/device';

const successCode = 0;

const deviceList = {
  name: 'deviceList',
  namespaced: true,
  actions: {
    // 列表
    List(state, params) {
      return new Promise((resolve, reject) => {
        getList(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetcurrentList(state, params) {
      return new Promise((resolve, reject) => {
        getcurrentList(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
      // try {
      //   const { data } = await getcurrentList(params)
      //   console.log(data)
      //       return data
      //   } catch (err) {
      //     console.log(err)
      //       throw new Error(err)
      //   }
    },
    //
    GetHistoryList(state, params) {
      return new Promise((resolve, reject) => {
        getHistoryList(params)
          .then((response) => {
            const { data, code, msg } = response;
            if (!data) {
              reject('暂无数据');
            }
            if (code === successCode) {
              resolve(data);
            } else {
              reject(msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default deviceList;
